import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/AddressSearchApi/" );

/* eslint-disable arrow-body-style */

/**
 * Search for a PAF address
 * @param {string} searchValue The value to search for
 */
export const pafAddressSearch = ( searchValue ) => {
  return instance.get( `SearchAddresses?searchValue=${searchValue}` );
};

/**
 * Load a full PAF address using a post key
 * @param {string} postKey The post key to use to load a full PAF address
 */
export const pafAddressLoad = ( postKey ) => {
  return instance.get( `LoadAddress?postKey=${postKey}` );
};

/**
 * Search for an organisation
 * @param {string} searchValue The value to search for
 * @param {number} searchType The type of search (definied in the customers database)
 */
export const orgAddressSearch = ( searchValue, searchType ) => {
  return instance.get( `SearchOrganisations?searchValue=${searchValue}&searchType=${searchType}` );
};

/**
 * Load a full organisations details
 * @param {GUID} orgId The ID of the organisation to load
 */
export const orgLoad = ( orgId ) => {
  return instance.get( `LoadOrganisation?id=${orgId}` );
};

/**
 * List all available countries
 */
export const listCountries = () => {
  return instance.get( "ListCountries" );
};
